import classNames from 'classnames';
import { isEqual } from 'lodash';
import React, { useContext, useState } from 'react';
import { RicosContext, ModalContext, EditorContext, PluginsEventsContext } from 'ricos-context';
import { SettingsMobileHeader, SettingsPanelHeader, SettingsPanelFooter } from 'wix-rich-content-ui-components';
import { s as styleInject } from '../style-inject.es-746bb8ed.js';
import { CollapsibleListSettings } from '../components/modal-components/CollapsibleListSettings.js';
import { collapsibleModals } from '../consts.js';
import { MODAL_ROOT } from '../dataHooks.js';
import { COLLAPSIBLE_LIST_TYPE } from '../types.js';
import 'wix-rich-content-plugin-commons';
import '@tiptap/pm/state';
import 'ricos-types';

var css_248z = ".w7sid{color:var(--ricos-settings-text-color,#333);display:flex;flex:1 1 auto;flex-direction:column;position:unset;z-index:5}[dir] .w7sid{background:#fff}[dir=ltr] .w7sid,[dir=rtl] .w7sid{left:0;right:0}.jjUC7{font-size:20px;position:absolute}[dir=ltr] .jjUC7{margin:24px 0 0 24px}[dir=rtl] .jjUC7{margin:24px 24px 0 0}.nt3Pi{width:100%}[dir] .nt3Pi{margin:70px auto 96px}[dir] .ymYFB{margin:0 auto}";
var styles = {"collapsibleListModal":"w7sid","collapsibleListModalTitle":"jjUC7","collapsibleListModal_scrollContainer":"nt3Pi","collapsibleListModal_mobile":"ymYFB"};
styleInject(css_248z);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const CollapsibleListSettingsModal = ({ nodeId, isQapageDataEnabled }) => {
  const { t, isMobile, languageDir } = useContext(RicosContext);
  const modalService = useContext(ModalContext) || {};
  const {
    adapter: { tiptapEditor },
    getEditorCommands
  } = useContext(EditorContext);
  const pluginsEvents = useContext(PluginsEventsContext);
  const [initialComponentData] = useState(
    () => getEditorCommands().getBlockComponentData(nodeId)
  );
  const fromComponentData = (componentData) => {
    const textDirectionToList = (textDirection) => {
      if (textDirection === "rtl") {
        return "RTL";
      }
      return "LTR";
    };
    return {
      initialExpanded: componentData.initialExpandedItems === "ALL" ? {
        type: "ALL"
      } : {
        type: componentData.initialExpandedItems,
        expandOnlyOne: componentData.expandOnlyOne
      },
      direction: (componentData == null ? void 0 : componentData.direction) || textDirectionToList(languageDir),
      isQapageData: !!componentData.isQapageData
    };
  };
  const toComponentData = (settings2, originalComponentData) => ({
    containerData: originalComponentData.containerData,
    expandOnlyOne: settings2.initialExpanded.type === "ALL" ? false : settings2.initialExpanded.expandOnlyOne,
    initialExpandedItems: settings2.initialExpanded.type,
    direction: settings2.direction,
    isQapageData: settings2.isQapageData
  });
  const toListAttributes = (value) => ({
    expandOnlyOne: value.initialExpanded.type === "ALL" ? false : value.initialExpanded.expandOnlyOne,
    initialExpandedItems: value.initialExpanded.type
  });
  const [settings, setSettings] = useState(
    () => fromComponentData(initialComponentData)
  );
  const pluginEvents = {
    onChangePluginSettings: (data) => pluginsEvents.publishPluginChangeSettings(__spreadProps(__spreadValues({}, data), { nodeId }))
  };
  const setCollapsibleListComponentData = (data) => {
    getEditorCommands().setBlock(nodeId, COLLAPSIBLE_LIST_TYPE, data);
  };
  const handleChange = (value) => {
    setSettings(value);
    setCollapsibleListComponentData(toComponentData(value, initialComponentData));
    tiptapEditor.chain().focus().setCollapsibleListAtributes(nodeId, toListAttributes(value));
  };
  const closeModal = () => {
    modalService.closeModal(collapsibleModals.settings);
  };
  const handleCancel = () => {
    const initialSettings = fromComponentData(initialComponentData);
    if (!isEqual(initialSettings, settings)) {
      handleChange(initialSettings);
    }
    closeModal();
  };
  return settings ? /* @__PURE__ */ React.createElement("div", { className: styles.collapsibleListModal, "data-hook": MODAL_ROOT, dir: languageDir }, isMobile ? /* @__PURE__ */ React.createElement(
    SettingsMobileHeader,
    {
      t,
      onCancel: handleCancel,
      onSave: closeModal,
      title: t("CollapsibleList_CollapsibleListSettings_Common_Header")
    }
  ) : /* @__PURE__ */ React.createElement(
    SettingsPanelHeader,
    {
      title: t("CollapsibleList_CollapsibleListSettings_Common_Header"),
      onClose: handleCancel
    }
  ), /* @__PURE__ */ React.createElement(
    "div",
    {
      className: classNames(styles.collapsibleListModal_scrollContainer, {
        [styles.collapsibleListModal_mobile]: isMobile
      })
    },
    /* @__PURE__ */ React.createElement(
      CollapsibleListSettings,
      {
        value: settings,
        onChange: handleChange,
        pluginEvents,
        isQapageDataEnabled
      }
    )
  ), !isMobile ? /* @__PURE__ */ React.createElement(SettingsPanelFooter, { fixed: true, cancel: handleCancel, save: closeModal, t }) : null) : null;
};

export { CollapsibleListSettingsModal as default };
//# sourceMappingURL=SettingsModals.js.map
